import React, { useState, useEffect, useRef, Fragment } from "react";
import { useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import moment from 'moment';
import Swal from 'sweetalert2'
import { useDownloadExcel } from 'react-export-table-to-excel';
import PageTitle from "../../Components/PageTitle.js";
import "react-toastify/dist/ReactToastify.css";
import { NavLink } from 'react-router-dom';
import { decodeToken, isExpired } from "react-jwt";

const MesajKutusu = () => {
    const location = useLocation();

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);

    const [data, setData] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const [prm, setPrm] = useState('');
    const [sort, setSort] = useState('');
    const [pageNo, setPageNo] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);    
    const [kutu, setKutu] = useState(0);
    const [arsivleGeriAlText, setArsivleGeriAlText] = useState("");

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true){
            getData();
        }
    }, [pageNo, pageSize, rowCount, sort, /*kutu,*/ prm, location]);

    /*useEffect(() => {
        let temp = window.location.pathname.split("/").pop();
        setKutu(temp);
        setArsivleGeriAlText(temp === "3" ? "Seçilenleri Geri Al" : "Seçilenleri Arşivle")
    }, [location]);*/


    const tableRef = useRef(null);

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'Mesajlar',
        sheet: 'Mesajlar'
    })

    const getAcilisData = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Ayarlar - Kullanıcılar - Mesajlaşma");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true){
            await getData();
        }
    }

    const getData = async () => {
        try {
            let kutu = window.location.pathname.split("/").pop();
            //setKutu(temp);
            setArsivleGeriAlText(kutu === "3" ? "Seçilenleri Geri Al" : "Seçilenleri Arşivle")

            const kriter = JSON.stringify({
                "gelenGidenArsiv": kutu,
                "searchText": prm,
                "sort": sort,
                "pageNo": pageNo,
                "pageSize": pageSize
            });

            const result = await axios.post(settings.ApiUrl + 'Mesaj/GetMesajKutusu', kriter, { headers: AuthService.getHeaders() });

            if (result) {
                setRowCount(result.data.rowCount);
                setLastPage(Math.ceil(result.data.rowCount / pageSize));
                setData(result.data.value);
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const handlePageSize = async (e) => {
        if (await tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
        await setPageSize(e);
    }

    const handlePageNo = async (e) => {
        if (await tokenYenile() === false) {
            return;
        }
        await setPageNo(e);
    }

    const NavIlk = async () => {
        if (await tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
    }

    const NavGeri = async () => {
        if ((pageNo - 1) >= 1) {
            if (await tokenYenile() === false) {
                return;
            }
            await setPageNo(pageNo - 1);
        }
    }

    const NavIleri = async () => {
        if ((Number(pageNo) + 1) <= lastPage) {
            if (await tokenYenile() === false) {
                return;
            }
            await setPageNo(Number(pageNo) + 1);
        }
    }

    const NavSon = async () => {
        if (await tokenYenile() === false) {
            return;
        }
        await setPageNo(lastPage);
    }

    const handlePrmChange = (e) => {
        if (tokenYenile() === false) {
            return;
        }

        setPrm(e.target.value);
    }

    const ArsivleVeyaGeriAl = async () => {
        if (await tokenYenile() === false) {
            return;
        }
        
        const dtos = data.filter(item => item.checked === true);

        if (dtos.length === 0) {
            Swal.fire({ title: "Hata", text: "En az bir satır seçiniz", icon: "error" });
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: kutu === "3" ? "Seçilen mesajlar geri alınacak, devam edilsin mi?" : "Seçilen mesajlar arşivlenecek, devam edilsin mi?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const resultArsivleVeyaGeriAl = await axios.post(settings.ApiUrl + 'Mesaj/UpdateMesajGonderilenKisiVeyaMesajSilVeyaGeriAl/', JSON.stringify(dtos), { headers: AuthService.getHeaders() });

                    if (resultArsivleVeyaGeriAl) {
                        if (resultArsivleVeyaGeriAl.data.success === true) {
                            await getData();
                            toast.success(kutu === "3" ? "Mesajlar geri alındı" : "Mesajlar arşivlendi");
                        } else {
                            toast.error(resultArsivleVeyaGeriAl.data.message);
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const handleCheckAll = () => {
        setCheckAll(!checkAll);

        const temp = data;

        temp.forEach(item => {
            item.checked = !checkAll;
        });

        setData(temp);
    }

    const handleItemCheck = (index, checked) => {
        const temp = [...data];
        temp[index].checked = checked;
        setData(temp);
    };

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div className="row">
                                <div className="col-md-12">
                                    <PageTitle></PageTitle>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <ul className="nav nav-tabs">
                                        <li className="nav-item">
                                            <NavLink className={kutu === "1" ? "nav-link active" : "nav-link"} to="/Mesaj/MesajKutusu/1">Gelen Mesajlar</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink className={kutu === "2" ? "nav-link active" : "nav-link"} to="/Mesaj/MesajKutusu/2">Giden Mesajlar</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink className={kutu === "3" ? "nav-link active" : "nav-link"} to="/Mesaj/MesajKutusu/3">Arşiv</NavLink>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-10">
                                    <button className="btn btn-sm btn-link" onClick={() => ArsivleVeyaGeriAl()}>{arsivleGeriAlText}</button>
                                </div>
                                <div className="col-md-2 text-right">
                                    <div className="input-group input-group-sm mb-3">
                                        <input type="text" className="form-control" aria-describedby="inputGroup-sizing-sm" placeholder="Arama..." value={prm} onChange={(e) => handlePrmChange(e)}></input>
                                        <span className="input-group-text" id="inputGroup-sizing-sm"><i className="bi bi-search"></i></span>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="card info-card mb-2">
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover table-sm mb-0">
                                                <thead>
                                                    <tr>
                                                        <th style={{ textAlign: "center" }}>
                                                            <input id="cbCheckAll" type="checkbox" checked={checkAll} onChange={handleCheckAll} className="form-check-input" style={{fontSize:"small"}}></input>
                                                        </th>
                                                        <th style={{ textAlign: "center" }}>Konu</th>
                                                        <th style={{ textAlign: "center" }}>Kişiler</th>
                                                        <th style={{ textAlign: "center" }}>Zaman</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        data && data.length > 0 ?
                                                            data.map((item, index) => {
                                                                return (
                                                                    <tr key={index} style={{fontWeight:item.bold === true ? "bold" : "normal"}}>
                                                                        <td align="center">
                                                                            <input id={"cb" + item.id} type="checkbox" className="form-check-input" checked={item.checked} onChange={() => handleItemCheck(index, !item.checked)}></input>
                                                                        </td>
                                                                        <td align="center">
                                                                            <NavLink className={item.bold === true ? "btn btn-sm btn-link p-0 fw-bold" : "btn btn-sm btn-link p-0"} to={"/Mesaj/MesajAc/" + (item.mesajGonderilenKisiId === 0 ? "2" : "1") + "/" + item.id}>{item.konu}</NavLink>
                                                                        </td>
                                                                        <td align="center">{item.kim}</td>
                                                                        <td align="center">{item.zaman === null ? "" : moment(item.zaman).format('DD.MM.YYYY HH:mm')}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td align="center" colSpan="4">
                                                                    Kayıt bulunamadı
                                                                </td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row" style={{ placeItems: "center", padding: "8px" }}>
                                            <div className="col-md-4" style={{ display: "ruby" }}>
                                                <span className="badge bg-primary">{rowCount + " kayıt"}</span>
                                                <button className="btn btn-sm btn-icon text-success" style={{ marginLeft: "16px" }} onClick={onDownload}><i className="bi bi-file-earmark-excel"></i></button>
                                            </div>
                                            <div className="col-md-4" style={{ textAlign: "-webkit-center" }}>
                                                <div style={{ display: "flex", width: "224px" }}>
                                                    <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIlk()}><i className="bi bi-caret-left-fill"></i></button>
                                                    <button className="btn btn-sm btn-icon text-info" onClick={async () => NavGeri()}><i className="bi bi-caret-left"></i></button>
                                                    <div className="input-group">
                                                        <input type="text" className="form-control form-control-xsm text-center" value={pageNo} onChange={(e) => handlePageNo(e.target.value)}></input>
                                                        <div className="form-control form-control-xsm text-center" style={{ borderLeft: "none" }}>{" / " + lastPage}</div>
                                                    </div>
                                                    <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIleri()}><i className="bi bi-caret-right"></i></button>
                                                    <button className="btn btn-sm btn-icon text-info" onClick={async () => NavSon()}><i className="bi bi-caret-right-fill"></i></button>
                                                </div>
                                            </div>
                                            <div className="col-md-4" style={{ textAlign: "-webkit-right" }}>
                                                <select className="form-select form-select-xsm" style={{ width: "128px" }} value={pageSize} onChange={async (e) => handlePageSize(e.target.value)}>
                                                    <option value="5">5 kayıt göster</option>
                                                    <option value="10">10 kayıt göster</option>
                                                    <option value="25">25 kayıt göster</option>
                                                    <option value="50">50 kayıt göster</option>
                                                    <option value="100">100 kayıt göster</option>
                                                    <option value="250">250 kayıt göster</option>
                                                    <option value="500">500 kayıt göster</option>
                                                    <option value="1000">1000 kayıt göster</option>
                                                    <option value="5000">5000 kayıt göster</option>
                                                    <option value="10000">10000 kayıt göster</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        :
                        ""
            }
        </Fragment>
    );
};

export default MesajKutusu;